import React, { useState } from "react";
import DynamicTable from "../../widgets/dynamicTable/DynamicTable.jsx";
import HelperMetiers360 from "../../../services/HelpersMetiers360.js";
import PropTypes from 'prop-types';
import '../preparatoryOrders/PreparatoryOrderTableComponent.scss';

const LoaderAccessPingsStatsTableComponent = ({ loaderAccessPings }) => {

    const [pauseDuration, setPauseDuration] = useState(60);

    const stringWithLeadingZeros = (string) => String(string).padStart(2, '0');
    const getDateFormat = (date) => typeof date === "string" || typeof date === "number"
        ? new Date(date)
        : date;

    const getHoursMinutes = (date) => stringWithLeadingZeros(getDateFormat(date)?.getHours()) + ":"
        + stringWithLeadingZeros(getDateFormat(date)?.getMinutes());
    const getMinutesNumber = (date) => getDateFormat(date)?.getHours() * 60 + getDateFormat(date)?.getMinutes();

    const getMinDateFromArray = (dates) => dates.reduce((a, b) => (a < b ? a : b));
    const getMaxDateFromArray = (dates) => dates.reduce((a, b) => (a > b ? a : b));

    const getMinOrMaxDateHourFromArray = (dates, minOrMax) => dates.map(d => getDateFormat(d))
        .reduce((earliest, current) => {
            const dateToMinutes = d => d.getHours() * 60 + d.getMinutes() + d.getSeconds() / 60;
            return dateToMinutes(current) < dateToMinutes(earliest)
                ? minOrMax === "min" ? current : earliest
                : minOrMax === "min" ? earliest : current;
        });

    const getDatesGroupedByPauses = (dates) => {
        if (!dates || dates.length === 0) return [];

        const sorted = dates.map(d => getDateFormat(d)).sort((a, b) => a - b);

        const groups = [];
        let start = sorted[0];
        let prev = start;

        for (let i = 1; i < sorted.length; i++) {
            const current = sorted[i];
            const diffHours = (current - prev) / (1000 * 60 * pauseDuration);

            if (diffHours > 1) {
                groups.push({
                    start: getDateFormat(start),
                    end: getDateFormat(prev)
                });
                start = current;
            }

            prev = current;
        }

        groups.push({ start: start.toISOString(), end: prev.toISOString() });

        return groups;
    }

    const getDataGroupedByDate = (data) => {
        if (!data || data.length === 0) return [];

        const groups = data.reduce((groups, ping) => {
            const date = ping.date?.split('T')?.[0]
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(ping);
            return groups;
        }, {});

        return Object.keys(groups).map((date) => {
            return {
                date,
                minDate: getMinDateFromArray(groups[date].map(d => d.date)),
                maxDate: getMaxDateFromArray(groups[date].map(d => d.date)),
                datesWithPauses: getDatesGroupedByPauses(groups[date].map(d => d.date)),
                pings: groups[date]
            };
        });
    }

    const getGlobalStats = (dataGroupDyDate) => {
        if (!dataGroupDyDate || dataGroupDyDate.length === 0) return [];

        return {
            minDate: getMinOrMaxDateHourFromArray(dataGroupDyDate.map(g => g.minDate), "min"),
            maxDate: getMinOrMaxDateHourFromArray(dataGroupDyDate.map(g => g.maxDate), "max"),
        }
    }

    const loaderAccessStats = getDataGroupedByDate(loaderAccessPings);
    const loaderAccessGlobalStats = getGlobalStats(loaderAccessStats);

    const today = new Date();
    const todayDate = HelperMetiers360.getdisplayDateType(today, 'day');

    const sortType = loaderAccessStats?.length > 0
        && [
            {
                value: 'date', label: 'Jour',
                test: HelperMetiers360.isArrayContainsValue(loaderAccessStats, "date"),
                method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.date, b.date),
                display: (loaderAccess) => {
                    if (loaderAccess?.date) {
                        const date = HelperMetiers360.getdisplayDateType(loaderAccess.date, 'day');
                        if (date == todayDate) {
                            return HelperMetiers360.getdisplayDateType(loaderAccess.date, 'day') + " (Aujourd'hui)"
                        }
                        return HelperMetiers360.getdisplayDateType(loaderAccess.date, 'day');
                    }
                    return '-';
                }
            },
            {
                value: 'stats', label: 'Statistiques',
                test: HelperMetiers360.isArrayContainsValue(loaderAccessStats, "minDate"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(getMinutesNumber(a.minDate), getMinutesNumber(b.minDate), true),
                display: (loaderAccess) => <div>
                    <p className="m-0">
                        Journée : <b>{getHoursMinutes(loaderAccess.minDate)} - {getHoursMinutes(loaderAccess.maxDate)}</b>
                    </p>
                    {loaderAccess.datesWithPauses?.length > 1 && <p className="my-2">
                        Répartition : {loaderAccess.datesWithPauses.map(data =>
                            <p className="m-0">{getHoursMinutes(data.start) + " - " + getHoursMinutes(data.end)}</p>
                        )}
                    </p>}
                </div>,
                flatDisplay: (loaderAccess) => `${getHoursMinutes(loaderAccess.minDate)} - ${getHoursMinutes(loaderAccess.maxDate)} (${loaderAccess.datesWithPauses.map(data => getHoursMinutes(data.start) + " - " + getHoursMinutes(data.end) + " / ")})`
            }
        ];
    return sortType && <>
        <div>
            <b>Statistiques générales :</b>
            <p className="mt-2 mb-0">Le plut tôt :&nbsp;
                <b>{getHoursMinutes(loaderAccessGlobalStats.minDate)}</b> ({HelperMetiers360.getdisplayDateType(loaderAccessGlobalStats.minDate, 'day')})</p>
            <p className="m-0">Le plus tard :&nbsp;
                <b>{getHoursMinutes(loaderAccessGlobalStats.maxDate)}</b> ({HelperMetiers360.getdisplayDateType(loaderAccessGlobalStats.maxDate, 'day')})</p>
        </div>
        <div className="mt-3">
            <p>Faire varier les périodes de répartition de la journée : <br />
                Une pause est comptée si il y a inactivité &gt;&nbsp;
                <input type="number" name='pauseDuration' id='pauseDuration' style={{ maxWidth: "5em" }}
                    defaultValue={pauseDuration} onChange={(e) => setPauseDuration(e?.target?.value ?? 60)}></input> minutes.</p>
        </div>
        <DynamicTable
            contentTable={loaderAccessStats}
            contentSort={sortType}
            valueInitSort="date"
            index='uniqueId'
            tableName="loaderAccessStatPingsTable"
            filename="loader_stat_pings"
        />
    </>;
};

LoaderAccessPingsStatsTableComponent.propTypes = {
    loaderAccessPings: PropTypes.array.isRequired,
};

export default LoaderAccessPingsStatsTableComponent;